import React from 'react';
import { Col, Container, Row, Accordion } from 'react-bootstrap';
import FaqComponents from "../../components/common/faq"; 

const faqs = [
    {
        question: "What does your custom software development company specialize in?",
        answer: `<p>Custom software development firms provide an array of services encompassing bespoke software solutions, web application development, mobile application development, cloud consulting, and expertise in DevOps practices. Building a custom software includes various steps from ideation and design to the core development and final testing of the product. Based on the suitable stack of the project requirements, a bespoke software development company in London can build a solution for multiple businesses.</p>`,
    },
    {
        question: "What industries do you serve with your custom software development services?",
        answer: `<p>We've curated a list of sectors that can experience substantial advantages through the utilization of tailored software development services.</p>
        <ul>
        <li>Healthcare</li>
        <li>Finance</li>
        <li>Education</li>
        <li>Retail</li>
        <li>Manufacturing</li>
        <li>Real Estate</li>
        <li>Transportation and Logistics</li>
    </ul>`,
    },
    {
        question: "Why hire a custom software development company?",
        answer: ` <p>Embarking on a custom software development project is a significant investment of both time and resources. However, opting to outsource the project can help your team in meeting deadlines and minimizing costs. By leveraging the external expertise of software development companies in UK, businesses often gain access to specialized skills and streamlined processes.</p>`,
    }, 
    {
        question: "What technologies do you use for custom software development?",
        answer: `  <p>Our custom software development company in London specializes in harnessing state-of-the-art technologies to provide unique and inventive solutions. Drawing on a varied technological toolkit, we apply languages such as JavaScript, Java, and Python, and leverage frameworks like React.js and Vue.js for the development of robust web and mobile applications. Our proficiency extends to cloud environments like AWS and Azure, facilitating smooth integration and scalability. We incorporate DevOps practices into our workflows to ensure streamlined collaboration with on-time delivery.</p>`,
    }, 
    {
        question: "How long does it typically take to develop a custom software solution?",
        answer: `<p>Usually, our software development projects span a timeline ranging from 4 to 9 months, with the project's size and complexity serving as the primary determinants of the overall duration. A project is deemed large or intricate if it meets any of the following criteria: it includes 25 or more screens.</p>`,
    },  
];

function FaqLocation(props) {
    return (
        <div className="faq_loc p-100 tekrevol_dark_bg">
        <Container className="h-100">
            <Row className="h-100">
                <Col
                    xs={12}
                    md={12}
                    lg={12}
                    xl={10}
                    xxl={10}
                    className="m-auto text-center"
                >
                    <div className="example center text-center" data-text="FAQs">
                        <h2>Frequently Asked Questions</h2>
                    </div>
                </Col>
            </Row>
            <Row className="h-100">
                <Col
                    xs={12}
                    md={12}
                    lg={12}
                    xl={12}
                    xxl={12}
                    className="services_faqs"
                >
                    <FaqComponents faqs={faqs} />
                </Col>
            </Row>
        </Container>
    </div>
    );
}

export default FaqLocation;